import React from "react";
import { newNode } from "./gradeMath";

/** Serial node graph, left-to-right (spec §2.1): add / delete / reorder /
 *  bypass / label. v1 = serial only. */
export const NodeStack = ({ nodes, activeIdx, onChange, onSelect }) => {
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= nodes.length) return;
    const next = [...nodes];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
    onSelect(j);
  };

  return (
    <div className="space-y-2" data-testid="grade-node-stack">
      <div className="flex items-center justify-between">
        <h3 className="text-xs font-mono uppercase tracking-widest text-white/40">Node Stack</h3>
        <button
          data-testid="grade-add-node-btn"
          onClick={() => { onChange([...nodes, newNode(`node ${nodes.length + 1}`)]); onSelect(nodes.length); }}
          className="text-xs px-2 py-1 rounded-md bg-orange-500/20 text-orange-300 hover:bg-orange-500/30 transition-colors">
          + Node
        </button>
      </div>
      {nodes.map((n, i) => (
        <div key={n.id}
          data-testid={`grade-node-${i}`}
          onClick={() => onSelect(i)}
          className={`group flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer transition-colors ${
            i === activeIdx ? "border-orange-500/60 bg-orange-500/10" : "border-white/10 bg-white/[0.03] hover:border-white/25"
          } ${n.enabled === false ? "opacity-40" : ""}`}>
          <span className="font-mono text-[10px] text-white/40">{String(i + 1).padStart(2, "0")}</span>
          <input
            value={n.label}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              const next = [...nodes];
              next[i] = { ...n, label: e.target.value };
              onChange(next);
            }}
            className="flex-1 bg-transparent text-sm text-white/80 outline-none min-w-0"
            data-testid={`grade-node-label-${i}`} />
          <button title={n.enabled === false ? "Enable" : "Bypass"}
            data-testid={`grade-node-toggle-${i}`}
            onClick={(e) => { e.stopPropagation(); const next = [...nodes]; next[i] = { ...n, enabled: n.enabled === false }; onChange(next); }}
            className="text-[10px] font-mono text-white/40 hover:text-orange-300">
            {n.enabled === false ? "OFF" : "ON"}
          </button>
          <div className="hidden group-hover:flex items-center gap-1">
            <button onClick={(e) => { e.stopPropagation(); move(i, -1); }} className="text-white/40 hover:text-white text-xs">↑</button>
            <button onClick={(e) => { e.stopPropagation(); move(i, 1); }} className="text-white/40 hover:text-white text-xs">↓</button>
            <button data-testid={`grade-node-delete-${i}`}
              onClick={(e) => { e.stopPropagation(); const next = nodes.filter((_, k) => k !== i); onChange(next); onSelect(Math.max(0, i - 1)); }}
              className="text-red-400/60 hover:text-red-400 text-xs">✕</button>
          </div>
        </div>
      ))}
      {nodes.length === 0 && (
        <p className="text-xs text-white/30 italic">No nodes — add one to start grading.</p>
      )}
    </div>
  );
};
